import { render, staticRenderFns, recyclableRender, components } from "./live-class-detail.vue?vue&type=template&id=e193dc86&"
var renderjs
import script from "./live-class-detail.vue?vue&type=script&lang=js&"
export * from "./live-class-detail.vue?vue&type=script&lang=js&"
import style0 from "./live-class-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uce-course/pages/detail/live-class-detail.vue"
export default component.exports